<template>
    <div class="right-column flex-1">
        <div class="text-white text-3xl mt-24 h-20">Meetings</div>

        <div v-if="bookings.length > 0" class="flex justify-left items-left mt-10">
            <ul
                role="list"
                class="overflow-y-scroll max-h-120 w-full scrollbar-hide py-4"
            >
                <li
                    v-for="booking in bookings"
                    :key="booking.id"
                    class="pb-8 w-full"
                >
                    <booking-list-item :booking="booking" />
                </li>
            </ul>
        </div>
    </div>
</template>

<script>
import BookingListItem from "./BookingListItem.vue";

export default {
    name: "BookingList",

    components: {
        BookingListItem,
    },

    props: {
        bookings: {
            type: Array,
            required: true,
            default: () => [],
        },
    },
};
</script>

<style scoped>
/* Scrollbar hide */
.scrollbar-hide::-webkit-scrollbar {
    display: none;
}
.scrollbar-hide {
    -ms-overflow-style: none;
    scrollbar-width: none;
}

/* Flexbox */
.flex {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
}
.flex-1 {
    -webkit-box-flex: 1;
    -ms-flex: 1 1 0%;
    flex: 1 1 0%;
}
.justify-left {
    -webkit-box-pack: start;
    -ms-flex-pack: start;
    justify-content: flex-start;
}
.items-left {
    -webkit-box-align: start;
    -ms-flex-align: start;
    align-items: flex-start;
}

/* Text Colors */
.text-white {
    color: #ffffff;
}

/* Text Size */
.text-3xl {
    font-size: 1.875rem;
    line-height: 2.25rem;
}

/* Spacing */
.mt-10 {
    margin-top: 2.5rem;
}
.mt-24 {
    margin-top: 6rem;
}
.pb-8 {
    padding-bottom: 2rem;
}
.py-4 {
    padding-top: 1rem;
    padding-bottom: 1rem;
}

/* Sizing */
.h-20 {
    height: 5rem;
}
.w-full {
    width: 100%;
}
.max-h-120 {
    max-height: 30rem;
}

/* Overflow */
.overflow-y-scroll {
    overflow-y: scroll;
}

/* Right column container */
.right-column {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-orient: vertical;
    -webkit-box-direction: normal;
    -ms-flex-direction: column;
    flex-direction: column;
}
</style>
